module.exports = __webpack_public_path__ + "img/title.20ab9b39.png";